import dblogo from "./assets/dblogo.svg";
import ImageWrapper from "./ImageWrapper";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Philanthropy } from "./Philanthropy";

function App() {
    return (
        <div className="App">
            <header className="App-header">
                <img src={dblogo} className="App-logo" alt="logo" />
            </header>
            <Router>
                <Switch>
                    <Route exact path="/">
                        <div className="flex-container">
                            <ImageWrapper />
                            <Philanthropy />
                        </div>
                    </Route>
                </Switch>
            </Router>
        </div>
    );
}

export default App;
